import { render, staticRenderFns } from "./profiles-list.vue?vue&type=template&id=86c6f7c0&"
import script from "./profiles-list.vue?vue&type=script&lang=js&"
export * from "./profiles-list.vue?vue&type=script&lang=js&"
import style0 from "./profiles-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports